var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cgqBox"},[_c('div',{staticClass:"cgqBoxTil"},[_vm._v("\n\t\t\t方寸精进·大钳道  "),_c('span',[_vm._v("*型号：VBC-ST30")])]),_c('div',{staticClass:"cgqBoxCen"},[_vm._v("\n\t\t\t在保持较细插入部的同时配备2.8mm钳道\n\t\t\t可更好地兼容手术诊疗耗材，同时保证镜下的吸引能力\n\t\t")]),_c('div',{staticClass:"cgqBoxSp"},[_c('img',{attrs:{"src":require("@/assets/product/page6/sp.png")}})])])])
}]

export { render, staticRenderFns }